import { render, staticRenderFns } from "./Logo3D.vue?vue&type=template&id=7a886878&"
import script from "./Logo3D.vue?vue&type=script&lang=js&"
export * from "./Logo3D.vue?vue&type=script&lang=js&"
import style0 from "./Logo3D.vue?vue&type=style&index=0&id=7a886878&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports